import { DEFAULT_RFQ_WORKFLOW_ID, DEFAULT_ORDER_WORKFLOW_ID } from '#types/Client.Parameters.types';
import type { Workflow } from '#types';

export function workflowNeedsRuntimeParameters(workflow: Workflow): boolean {
  const hasUserParameters = (workflow.userParameters ?? []).length > 0;
  const hasSendActionRequiringParams = (workflow.actions ?? []).some(
    (action) => action.actionType === 'send' && action.targetsParameterId
  );
  const hasSavePdfToForm = (workflow.actions ?? []).some(
    (action) => action.actionType === 'savePdfToForm'
  );
  return hasUserParameters || hasSendActionRequiringParams || hasSavePdfToForm;
}

export function workflowNavigatesToNewForm(workflow: Workflow): boolean {
  return (workflow.actions ?? []).some(
    (action) => action.actionType === 'createForm' && action.navigateToNewForm === true
  );
}

export function isCreateQuoteWorkflow(workflow: Workflow): boolean {
  return (workflow.actions ?? []).some((action) => {
    return action.actionType === 'callSignifyApi' && action.apiEndpoint === 'createQuote';
  });
}

export function selectCreateQuoteWorkflow(workflows: Workflow[]): Workflow | null {
  const createQuoteWorkflows = workflows.filter(isCreateQuoteWorkflow);
  if (createQuoteWorkflows.length === 0) return null;
  const preferred = createQuoteWorkflows.find((workflow) => workflow.docId === DEFAULT_RFQ_WORKFLOW_ID);
  return preferred ?? createQuoteWorkflows[0] ?? null;
}

export function isCreateOrderWorkflow(workflow: Workflow): boolean {
  return (workflow.actions ?? []).some((action) => {
    return action.actionType === 'callSignifyApi' && action.apiEndpoint === 'createOrder';
  });
}

export function selectCreateOrderWorkflow(workflows: Workflow[]): Workflow | null {
  const createOrderWorkflows = workflows.filter(isCreateOrderWorkflow);
  if (createOrderWorkflows.length === 0) return null;
  const preferred = createOrderWorkflows.find((workflow) => workflow.docId === DEFAULT_ORDER_WORKFLOW_ID);
  return preferred ?? createOrderWorkflows[0] ?? null;
}
